<section class="h-100 gradient-custom">
    <link href='https://fonts.googleapis.com/css?family=Noto Sans' rel='stylesheet'>
    <div class="container py-5">
        <div class="row d-flex justify-content-center my-4">
            <div class="col-md-8">
                <div class="card mb-4">
                    <div class="card-header py-3">
                        <div class="productInfo">
                            <div class="text"><a><img class="bayerLogo" src="assets/logo_bayer.svg"
                                        alt="logo" />Bayer</a></div>
                        </div>
                        <div class="dividerLine">
                            <hr>
                        </div>
                    </div>
                    <div class="card-body" style="margin-top: 60px; text-align: center;">
                        <div class="row">
                            <div class="col-lg-5 col-md-6 mb-4 mb-lg-0">
                                <p class="productName"><strong>{{errorMessage}}</strong></p>
                                <p class="productName">{{errorDescription}}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <body style="margin-top:40px;">
                    <div class="col-12">
                        <a href="javascript:void(0);" onclick="window.open">
                            <img class="bannerImages" style="padding-top:12px;
                                             box-sizing: border-box;" src="../../assets/english_banner_1.jpg" alt=""
                                (click)="openMobileApp('farmrise_banner_1')" />
                        </a>
                        <a href="javascript:void(0);" onclick="window.open">
                            <img class="bannerImages" style="padding-top:10px; padding-bottom: 16px;
                                        box-sizing: border-box;" src="../../assets/english_banner_2.jpg" alt=""
                                (click)="openMobileApp('farmrise_banner_2')" />
                        </a>
                    </div>
                </body>
            </div>
        </div>
    </div>
</section>